import { Icon } from '../../../../core/components/atoms/Icon';

const SearchInput = ({
  search,
  setSearch,
  placeholder,
}: {
  search: string;
  setSearch: (value: string) => void;
  placeholder?: string;
}) => {
  return (
    <div className='shadow-sm flex h-[30px] w-full max-w-md items-center gap-2 rounded-[64px] bg-[#B9C1C9] px-2 py-2'>
      <Icon
        Icon='search'
        type='material'
        className='h-[12px] w-[8px] text-xs text-[#3E4752]'
      />
      <input
        type='text'
        placeholder={placeholder || ''}
        className=' !focus:ring-0 w-full text-xs text-[#3E4752] placeholder-[#3E4752] outline-none focus:outline-none focus:ring-0'
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
        }}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    </div>
  );
};

export default SearchInput;
